import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { selectIsBillingDisabled, selectNextResetLabel } from 'containers/Agents/creditSelectors'
import {
  selectActualIntegrations,
  selectData,
  selectError,
  selectLoader,
} from 'containers/App/selectors'

import SystemNotificationsModal from 'components/pages/navigation/SystemNotifications'

import actions from './actions'

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)
const mapStateToProps = (state) => ({
  data: selectData(state),
  loader: selectLoader(state),
  error: selectError(state),
  integrations: selectActualIntegrations(state),
  isBillingDisabled: selectIsBillingDisabled(state),
  creditResetLabel: selectNextResetLabel(state),
})
const render = connect(mapStateToProps, mapDispatchToProps)(SystemNotificationsModal)

export default withRouter(render)
